import React, { useEffect, useState } from "react";

import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import {
  setPerPageSize,
  setDetails,
  deleteRecord,
  fetchList,
} from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import ViewDrawer from "./components/ViewDrawer";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
import { TestimonialBreadcrumb } from "../../../config/BreadcrumbConfig";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";

const moduleInfo = {
  title: "Testimonial",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Testimonial"),
};

/**
 * Renders the Testimonial module component.
 *
 * @return {ReactElement} The rendered component.
 */
const Testimonial: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector(state => state.testimonial);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [viewDrawer, setViewDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);

  return (
    <>
      <ToolBar breadcrumbs={TestimonialBreadcrumb}>
        <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPageSize(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleViewClick={(data: any) => {
            dispatch(setDetails(data));
            setViewDrawer(true);
          }}
          handleEditClick={(data: any) => {
            setEditDrawer(true);
            dispatch(setDetails(data));
          }}
          handleDeleteClick={setDeleteValue}
        />
        <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() => setIsCreateVisible(false)}
        />
        <ViewDrawer
          titleName={moduleInfo.title}
          open={viewDrawer}
          close={() => dispatch(setDetails(null)) && setViewDrawer(false)}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
      </ContentBox>
    </>
  );
};

export default Testimonial;
